import { cx } from "@/utils/cx";
import type { HTMLAttributes } from "react";

/**
 * Gymkee 2027 skeleton (spec skeleton 1.4; sheet DS29).
 *
 * A paper-muted block at the exact height of the thing it stands for, at radius control or
 * radius pill for an avatar. The wash is the 55 percent paper gradient crossing it over 1.6 s
 * (`.ds-skeleton` in src/design/motion.css), and it is absent under reduced motion. Never grey,
 * never a pulsing card, and never shown beside a crescent for the same wait.
 */

interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** The circle an avatar leaves behind, at the avatar's real diameter. */
  circle?: boolean;
}

export function Skeleton({
  className,
  circle,
  style,
  ...props
}: SkeletonProps) {
  return (
    <div
      aria-hidden="true"
      className={cx(
        "ds-skeleton",
        circle ? "rounded-pill" : "rounded-control",
        className,
      )}
      style={{ background: "var(--gk-surface-paper-muted)", ...style }}
      {...props}
    />
  );
}
